import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { withArtifex } from "core";
import PropTypes from "prop-types";
import React from "react";
import { GenericGrid, GenericNumberInput, GenericSelectInput, GenericTextInput, GenericTitle } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";


class Province extends React.Component {
	constructor(props) {
		super(props);
		this.initialModel = {
			Id: 0,
			Name: null,
			CountryId: null
		};
		this.state = {
			model: { ...this.initialModel },
			provinceList: [],
			totalresult: {},
			checkedValues: [],
			selected: null,
			isLoading: false,
			alert: "",
			IsUpdate: false,
			vModel: {},
		};
		this.emptyObject = {};

		this.columns = [
			{
				Header: "Country Name",
				accessor: "Country.Name"
			},
			{
				Header: "Name",
				accessor: "Name"
			}
		];
	}

	componentDidMount() {

	}
	ValueChanged = (name, value, data) => {
		const model = { ...this.state.model };
		model[name] = value;
		this.setState({ model });
	}

	HandleClear = () => {
		this.setState({ model: { ...this.initialModel }, isEdit: false, index: -1 });
		this.props.OnModelChange("Province", null);

	}

	HandleSearch = async () => {
		this.setState({ isLoading: true });
		const { ExecuteApiPost } = this.props;
		this.state.model.CountryId = this.props.CountryId;
		var result = await ExecuteApiPost("/bankapi/v1.0/WireProvince/Search", this.state.model);
		this.setState({ isLoading: false });

		if (result != null) {
			this.setState({ provinceList: result || [] });
		}
	}

	HandleSubmit = async () => {
		if (!this.Validate()) {
			return;
		}

		const { ExecuteApiPost } = this.props;
		var result = await ExecuteApiPost("/bankapi/v1.0/WireProvince/Insert", this.state.model);

		if (result != null) {
			this.HandleSearch();
		}
	}

	HandleUpdate = async () => {
		if (!this.Validate()) {
			return;
		}
		const { ExecuteApiPost } = this.props;
		var result = await ExecuteApiPost("/bankapi/v1.0/WireProvince/Update", this.state.model);

		if (result != null) {
			this.HandleSearch();
		}
	}

	HandleDelete = () => {
		const { ExecuteApiPost, showConfirmMessage } = this.props;
		showConfirmMessage("warning", "Warning", "Are you sure want to delete ?", () => ExecuteApiPost("/bankapi/v1.0/WireProvince/Delete", { Id: this.state.model.Id }, null, null, null, [this.HandleSearch], true));
	}

	Validate() {
		const { model, vModel } = this.state;
		var messages = [];
		const { showValidationErrors, CountryId } = this.props;
		vModel.CountryId = !CountryId;
		if (vModel.CountryId) {
			messages.push("Country cannot be empty!");
		}
		vModel.Name = !model.Name;
		if (vModel.Name) {
			messages.push("Name cannot be empty!");
		}
		if (messages.length > 0) {
			showValidationErrors(messages);

			return false;
		}
		return true;
	}
	RowSelected = (index) => {
		var tempModel = this.state.provinceList[index];
		this.setState({ isEdit: true, model: tempModel, index });
		this.props.OnModelChange("Province", tempModel.Id);

	}
	render() {
		const { model, provinceList, vModel } = this.state;
		const { Disabled, CountryId } = this.props;

		return (
			<div>
				<LoadingComponent Show={this.state.isLoading} />

				{this.state.alert}
				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<CardHeader>
									<GenericTitle text={"Province List"} />
								</CardHeader>
								<GridContainer justify="flex-end">

									<GridItem justify="flex-end">
										<Button size="sm" onClick={() => this.HandleSubmit()} disabled={model.Id > 0}>
											SUBMIT
							         	</Button>
										<Button size="sm" onClick={() => this.HandleSearch()}>
											SEARCH
							         	</Button>
										<Button size="sm" onClick={() => this.HandleUpdate()} disabled={model.Id == 0}>
											UPDATE
							         	</Button>
										<Button size="sm" onClick={() => this.HandleDelete()} disabled={model.Id == 0} >
											DELETE
							         	</Button>
										<Button size="sm" onClick={() => this.HandleClear()}>
											CLEAR
							         	</Button>
									</GridItem>

								</GridContainer>
								<GridItem xs={12}>
									<GridContainer>

										<GridItem xs={4}>
											<GenericSelectInput
												Name="CountryId"
												LabelText="Country"
												Method="POST"
												Url="/bankapi/v1.0/WireCountry/Search"
												Parameter={this.emptyObject}
												DataRoot="Item"
												KeyValueMember="Id"
												TextValueMember="Name"
												Value={CountryId}
												ValueChanged={this.ValueChanged}
												Disabled={true}
												Required
												IsInvalid={vModel.CountryId}
											/>
										</GridItem>
										<GridItem xs={4}>
											<GenericTextInput
												Name="Name"
												Value={model.Name}
												LabelText="Name"
												ValueChanged={this.ValueChanged}
												Required
												IsInvalid={vModel.Name}
											/>
										</GridItem>

									</GridContainer>
								</GridItem>
								<br />
								<GridContainer>
									<GridItem xs={12}>
										<GridContainer spacing={16}>
											<GridItem xs={12}>
												<GenericGrid
													Columns={this.columns}
													Data={provinceList}
													ShowPagination={true}
													HideButton={true}
													PageSize={10}
													RowSelected={this.RowSelected}
												/>
											</GridItem>
										</GridContainer>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

Province.propTypes = {
	Disabled: PropTypes.bool,
	menuId: PropTypes.any,
	ApprovalData: PropTypes.any,
	After: PropTypes.any,
	classes: PropTypes.object,
	ExecuteApiPost: PropTypes.func,
	OnModelChange: PropTypes.func,
	showConfirmMessage: PropTypes.func,
	showValidationErrors: PropTypes.func
};

export default withArtifex(Province, {});